// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import {
  trim as _trim,
} from 'lodash-es';
import {dispatchLayoutChange, tryExecution} from '../_util';
import $ from 'jquery';
import runOnVisible from '../runner-visible';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'big-leaf';
const slidableBreakpoint = '576px';

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

class BigLeaf {
  constructor(el) {
    this._activeTabId = false;
    this._sliderActivated = false;

    this.el = el;
    this.$nav = null;
    this.$navButtons = null;
    this.$tabs = $(el).find(`.${baseClass}__tab`);

    this.swiper = null;
    this.mediaMatcher = window.matchMedia(`(max-width: ${slidableBreakpoint})`);

    this.$swiperNav = null;
    this.$swiperNavInner = null;
    this.$swiperNavButtons = null;

    runOnVisible(this.el, async () => {
      this.createTabNav();

      const { default: Swiper } = await import('swiper/core');
      if (this.mediaMatcher.matches) {
        this.initSlider(Swiper);
      } else {
        await this.initNavSlider(Swiper);
      }

      this.mediaMatcher.addEventListener('change', (event) => {
        if (event.matches) {
          this.initSlider(Swiper);
        } else {
          this.destroySlider(Swiper);
        }
      });

    });

  }

  createTabNav() {
    if (!this.$tabs.length) return;
    const $nav = $(`<nav class="${baseClass}__nav" />`);
    const $ul = $('<ul />');

    const $swiperNav = $(`<div class="swiper-navigation" />`);
    const $swiperNavInner = $(`<div class="swiper-navigation__inner" />`);
    const $swiperNavButtonPrev = $(`<div class="swiper-button-prev" />`);
    const $swiperNavButtonNext = $(`<div class="swiper-button-next" />`);

    $swiperNavButtonPrev.append($swiperNavInner).appendTo($swiperNav);
    $swiperNavButtonNext.append($swiperNavInner).appendTo($swiperNav);
    $swiperNavInner.append($ul).appendTo($swiperNav);

    $ul.addClass('swiper-wrapper');
    this.$tabs.each((i, e) => {
      const $li = this.createTabNavItem(e);
      if ($li) $ul.append($li);
    });
    $nav.append($ul).prependTo(this.el);
    this.$nav = $nav;
    this.$navButtons = $nav.find('button');
    this.$navButtons.first().trigger('click');
    $(this.el).toggleClass(`${baseClass}--tabbed`, (this.$tabs.length >= 2));
    $swiperNav.prependTo($(this.el).find(`.${baseClass}__nav`));
  }

  createTabNavItem(tabEl) {
    const tabId = tabEl.id;
    const id = tabEl.getAttribute('aria-labelledby');
    const label = _trim(tabEl.dataset.label);
    const icon = _trim(tabEl.dataset.icon);
    if (!tabId.length || !id.length || !label.length) return null;
    const $li = $('<li />');
    $li.addClass('swiper-slide');
    const $btn = $(`<button id="${id}" type="button" aria-controls="${tabId}" />`);
    if (icon.length) $btn.append(`<i class="fa fa-${icon}" aria-hidden="true" />`);
    $btn.on('click', () => {
      this.activeTabId = tabId;
    }).append(`<span>${label}</span>`).appendTo($li);
    return $li;
  }

  async initNavSlider(Swiper) {
    this.swiper = new Swiper($(this.el).find(`.${baseClass}__nav`)[0], {
      slidesPerView: "auto",

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });
  }

  initSlider(Swiper) {
    if (this._sliderActivated || this.$tabs.length < 2) {
      return;
    }

    this.swiper = new Swiper($(this.el).find(`.${baseClass}__inner`)[0], {
      slidesPerView: "auto",
      spaceBetween: 20,
      centeredSlides: true,

      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    this.$tabs.fadeIn();

    this._sliderActivated = true;
  }

  destroySlider() {
    if (this._sliderActivated === false || this.$tabs.length < 2) {
      return;
    }

    this.swiper.destroy();
    this.swiper = null;

    this._sliderActivated = false;
  }

  set activeTabId(id) {
    const firstSet = this._activeTabId === false;

    this._activeTabId = id;

    let tabAnimation = this.$tabs.attr({
      'aria-hidden': true,
      'aria-expanded': false,
    })
    .removeClass('active')
    .stop();

    if (firstSet === false) {
      tabAnimation.fadeOut();
    }

    tabAnimation = tabAnimation.filter(`[id="${id}"]`)
      .attr({
        'aria-hidden': false,
        'aria-expanded': true,
      })
      .addClass('active');

    if (firstSet === false) {
      tabAnimation.fadeIn({
        start: () => dispatchLayoutChange(),
      });
    } else {
      dispatchLayoutChange();
    }

    this.$navButtons.removeClass('active')
      .filter(`[aria-controls="${id}"]`)
      .addClass('active');
  }

  get activeTabId() {
    return this._activeTabId;
  }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

function init() {
  $(`.${baseClass}`).each((i, el) => tryExecution(() => new BigLeaf(el)));
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
